import {path, pipe, prop} from 'ramda';
import namespace from './namespace';
import {createSelector} from 'reselect';
import {selectors as lifecycleSelectors} from 'fragments/lifecycle';
import {
	formatUrlQuery,
	formatFetchableBuildingsQuery,
	formatBuildingsSearchInput,
	formatCallCampaignsFormInitValues,
} from './utils';

const root = path(namespace);

export const {seq} = lifecycleSelectors(namespace);

export const initialized = pipe(seq, x => !!x);

export const buildingsQuery = pipe(root, prop('buildingsQuery'));

export const buildingsQueryFetchable = createSelector(
	[buildingsQuery],
	buildingsQuery => {
		return formatFetchableBuildingsQuery({buildingsQuery});
	},
);

export const urlQuery = createSelector([buildingsQuery], buildingsQuery => {
	return formatUrlQuery({buildingsQuery});
});

export const buildings = pipe(root, prop('buildings'));

export const buildingsPagination = pipe(root, prop('buildingsPagination'));

export const buildingsLoading = pipe(root, prop('buildingsLoading'));

export const dismissPrompt = createSelector(
	[buildingsQuery],
	buildingsQuery => buildingsQuery.dismissPrompt,
);

export const processing = pipe(root, prop('processing'));

export const areasSelectorOpen = pipe(root, prop('areasSelectorOpen'));

export const areasSelectorSearch = pipe(root, prop('areasSelectorSearch'));

export const buildingsSearchInitValues = createSelector(
	[buildingsQuery],
	buildingsQuery => formatBuildingsSearchInput({buildingsQuery}),
);

export const callCampaigns = pipe(root, prop('callCampaigns'));

export const callCampaignsFormInitValues = createSelector(
	[buildingsQuery],
	buildingsQuery => formatCallCampaignsFormInitValues({buildingsQuery}),
);

export const activeCallCampaign = createSelector(
	[buildingsQuery],
	buildingsQuery => buildingsQuery.campaign,
);

export const callCampaignCreatorOpen = pipe(root, prop('callCampaignCreatorOpen'));

export const lastVisitedBuilding = pipe(root, prop('lastVisitedBuilding'));

export const lastVisitedBuildingLoading = pipe(root, prop('lastVisitedBuildingLoading'));
